import { useSelector } from "react-redux";



export const usePermission = () => {
    const { list, loaded } = useSelector(state => state.permissions);

     const hasPermission = (permission) => {
    return list.includes(permission);
  };

  return { hasPermission, permissionsLoaded: loaded };

}

